import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useGameplayInsightsStore = defineStore('gameplayInsights', () => {
  const isVisible = ref(false)
  const popupProps = ref({
    playerId: '',
    playerEmail: ''
  })

  const show = (props: {
    playerId: string
    playerEmail?: string
  }) => {
    popupProps.value = {
      playerId: props.playerId,
      playerEmail: props.playerEmail || ''
    }
    isVisible.value = true
  }

  const close = () => {
    isVisible.value = false
  }

  return {
    isVisible,
    popupProps,
    show,
    close
  }
}) 